import classNames from 'classnames'
import React, { type JSX } from 'react'

import { colors, type ColorVariant } from '@/utils/theme'
import './Text.scss'

type TextVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'callout'
  | 'text'
  | 'textblock'
  | 'footnote'

interface TextProps {
  children: React.ReactNode
  variant?: TextVariant
  align?: 'left' | 'center' | 'right'
  color?: ColorVariant
  className?: string
  maxLines?: number
  style?: React.CSSProperties
}

const variantMap: Record<TextVariant, keyof JSX.IntrinsicElements> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  callout: 'p',
  text: 'p',
  textblock: 'p',
  footnote: 'small',
}

function Text({
  children,
  variant = 'text',
  align = 'left',
  color,
  className,
  maxLines,
  style,
}: TextProps) {
  const Component = variantMap[variant] || 'span'

  return (
    <Component
      style={{ color: color ? colors[color] : undefined, WebkitLineClamp: maxLines, ...style }}
      className={classNames(variant, className, 'text', { 'max-lines': maxLines })}
      align={align}
    >
      {children}
    </Component>
  )
}

export default Text
